import { render, staticRenderFns } from "./attendance.vue?vue&type=template&id=023d2364&scoped=true"
import script from "./attendance.vue?vue&type=script&lang=js"
export * from "./attendance.vue?vue&type=script&lang=js"
import style0 from "./attendance.vue?vue&type=style&index=0&id=023d2364&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d2364",
  null
  
)

export default component.exports